module.exports = __webpack_public_path__ + "img/k12_feature5.2cdd9ed3.png";